/**
 * @remarks Formily / Designable 历史兼容常量
 * @author ickeep <i@ickeep.com>
 * @module @yimoka/designable-playground
 */

import { TreeNode, type ITreeNode } from '@yimoka/designable-core';

import type { ISchemaTransformer } from '../types';

export const HISTORICAL_FIELD_COMPONENT_NAME = 'Field';

export const DEFAULT_FORMILY_COMPONENT_NAME_ALIASES: Record<string, string> = {
  'ArrayTable.Column': 'ArrayTableColumn',
  'Checkbox.Group': 'Checkbox',
  'DatePicker.RangePicker': 'DateRangePicker',
  'FormCollapse.CollapsePanel': 'FormCollapsePanel',
  'FormGrid.GridColumn': 'FormGridColumn',
  'Input.TextArea': 'TextArea',
  InputNumber: 'NumberPicker',
  'Radio.Group': 'Radio',
  'TimePicker.RangePicker': 'TimeRangePicker',
  'Upload.Dragger': 'Upload',
};

export const IGNORED_HISTORICAL_FORMILY_COMPONENT_NAMES = new Set([
  'ArrayCards.Addition',
  'ArrayCards.Index',
  'ArrayCards.MoveDown',
  'ArrayCards.MoveUp',
  'ArrayCards.Remove',
  'ArrayTable.Addition',
  'ArrayTable.Index',
  'ArrayTable.MoveDown',
  'ArrayTable.MoveUp',
  'ArrayTable.Remove',
  'ArrayTable.SortHandle',
]);

export const HISTORICAL_FORMILY_TREE_COMPONENT_NAMES = new Set([
  ...IGNORED_HISTORICAL_FORMILY_COMPONENT_NAMES,
  ...Object.keys(DEFAULT_FORMILY_COMPONENT_NAME_ALIASES),
]);

export const hasHistoricalFormilyTreeSchemaNode = (schema: ITreeNode): boolean => (
  (
    schema.componentName === HISTORICAL_FIELD_COMPONENT_NAME
    && typeof schema.props?.['x-component'] === 'string'
  )
    || (typeof schema.componentName === 'string' && HISTORICAL_FORMILY_TREE_COMPONENT_NAMES.has(schema.componentName))
    || Boolean(schema.children?.some(hasHistoricalFormilyTreeSchemaNode))
);

export const normalizeHistoricalFormilyTreeSchema = <S = unknown>(
  schema: ITreeNode,
  transformer?: ISchemaTransformer<S>,
) => {
  if (!transformer || !hasHistoricalFormilyTreeSchemaNode(schema)) return schema;
  return transformer.toTreeNode(transformer.toSchema(new TreeNode(schema)));
};
